import React from 'react'
import close from '../../assets/images/close.svg'

const DeleteLocationPopup = ({ showDeletePopup, setShowDeletePopup, confirmDelete, refrence, styles, isLoadingDeleteLocation }) => {
    return (
        <>
            {showDeletePopup && (
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box add-new-user" ref={refrence}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => setShowDeletePopup(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>Delete Location</div>
                        <div>
                            <p>Are you sure you want to delete this location?</p>
                            <div style={{display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px'}}>
                                <button
                                    className={styles.addBtn}
                                    onClick={() => setShowDeletePopup(false)}
                                    
                                >
                                    Cancel
                                </button>
                                <button
                                    className={`${styles.addBtn} deleteLocation`}
                                    onClick={confirmDelete}
                                    
                                >
                                    {isLoadingDeleteLocation ? <div className={`ringLoader`}></div> : 'Delete'}
                                    
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default DeleteLocationPopup;